module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nfl/icons_receiving_yds/green-680a03cbe59a2f79ec0562712f3e3aee.svg";